export type ReactivationProcedurePayload = {
	signatureRequestId: string
	expiration_date: string
}

export type ReactivationProcedureForm = {
	expiration_date: Date | null
}

export const INITIAL_REACTIVATION_PROCEDURE: ReactivationProcedureForm = {
	expiration_date: null
}